import { useSelector } from "react-redux";
import SettingsPrincipal from "./principal/SettingsPrincipal.js";
import SettingsTeacher from "./teacher/SettingsTeacher.js";
import SettingsStudent from "./student/SettingsStudent.js";
import SettingsBilling from "./billing/SettingsBilling.js";
import SettingsTransport from "./transport/SettingsTransport.js";
import SettingsOnboarding from "./onboarding/SettingsOnboarding.js";
import SettingsInventory from "./inventory/SettingsInventory.js";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
import SettingsParent from "./parent/SettingsParent.js";
import SettingsIT from "./IT/SettingsIT.js";
import SettingsIT2 from "./IT2/SettingsIT2.js";

function Settings() {
  const state = useSelector((state) => state);
  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <SettingsPrincipal />;
    }
    if (state.auth.user.is_teacher) {
      return <SettingsTeacher />;
    }
    if (state.auth.user.is_student) {
      return <SettingsStudent />;
    }
    if (state.auth.user.is_onboarding) {
      return <SettingsOnboarding />;
    }
    if (state.auth.user.is_billing) {
      return <SettingsBilling />;
    }
    if (state.auth.user.is_transport) {
      return <SettingsTransport />;
    }
    if (state.auth.user.is_inventory) {
      return <SettingsInventory />;
    }
    if (state.auth.user.is_parent) {
      return <SettingsParent />;
    }
    if (state.auth.user.is_attendance) {
      return <SettingsIT />;
    }
    if (state.auth.user.is_attendance2) {
      return <SettingsIT2 />;
    }
    return <PermissionDenied />;
  }
}

export default Settings;
